import { Message } from 'ds-views'

interface AuthorMenu {
  authority: string

  [propName: string]: any
}

const changeParse = function (data: any) {
  return JSON.parse(JSON.stringify(data))
}

const hourTime = function (timestamp: string | number | Date) {
  const time = new Date(timestamp)
  const year = time.getFullYear()
  const month = getDoubleDigits(time.getMonth() + 1)
  const date = getDoubleDigits(time.getDate())
  const hour = getDoubleDigits(time.getHours())
  const minutes = getDoubleDigits(time.getMinutes())
  const seconds = getDoubleDigits(time.getSeconds())
  return `${year}-${month}-${date} ${hour}:${minutes}:${seconds}`

  function getDoubleDigits(num: string | number) {
    const criticalNum = 10
    return num < criticalNum ? '0' + num : num
  }
}

const messageTip = function (message: string, type: 'success' | 'warning' | 'info' | 'error') {
  Message({
    message: message,
    type: type,
    duration: 1500
  })
}

// 密码验证
const checkPass = function (pass: string) {
  let i = 0
  if (pass.match(/([a-z])+/)) {
    i++
  }
  if (pass.match(/([A-Z])+/)) {
    i++
  }
  if (pass.match(/([0-9])+/)) {
    i++
  }
  const pattern = new RegExp('[`~!@#$^&*()=|{}\':;,\\[\\].<>《》/?！￥…（）—【】‘；：”“。，、？]')
  if (pattern.test(pass)) {
    i++
  }
  return i
}

const validatePass = (rule: any, value: string, callback: Function) => {
  const minPasswordNum = 6
  const minPasswordType = 2
  if (value === '') {
    callback(new Error('请输入密码'))
  } else {
    if (value.length < minPasswordNum) {
      callback(new Error('密码至少需要6位'))
    }
    if (checkPass(value) < minPasswordType) {
      callback(new Error('密码需包含字母大小写、数字、特殊字符的任意两种！'))
    }
    callback()
  }
  // callback()
}

const authorMenu = function (value: IUser) {
  switch (value.authority) {
    case 'generalUser':
    case 'customerOperator':
    case 'dsProductOperator':
    case 'dsProductManager':
    case 'dsAdmin':
      return ['account']
    case 'admin':
      return ['account', 'audit']
    default:
      return []
  }
}

const timeDelay = 500
const debounce = function (fn: Function, delay = timeDelay) {
  let timer: any = null
  return function (...args: any[]) {
    timer && clearTimeout(timer)
    timer = setTimeout(() => {
      fn(...args)
    }, delay)
  }
}

export {
  messageTip,
  changeParse,
  checkPass,
  authorMenu,
  hourTime,
  debounce,
  validatePass,
}
